import { Schema } from '@core/data/dto/schema';
import { DeliveryOrderQuote } from './quote/delivery-order-quote';
import { DeliveryOrderDropoff } from './dropoff/delivery-order-dropoff';
import { FORMAT } from '@core/utils/formats';
import { getLocalMomentFromUtc } from '@core/utils/date-time';
import { DeliveryOrderCourier } from './courier/delivery-order-courier';
import { DeliveryOrderDriver } from './driver/delivery-order-driver';
import { DeliveryOrderManagerNote } from './manager-note/delivery-order-manager-note';
import { DeliveryOrderPickup } from './pickup/delivery-order-pickup';
import { DeliveryOrderRefund } from './refund/delivery-order-refund';


export const DeliveryOrderSchema = {
    id: Schema.String,
    external_id: Schema.String,
    external_code: Schema.String,
    order_reference: Schema.String,
    reference: Schema.String,
    order_type: Schema.Auto,
    order_id: Schema.String,
    status: Schema.Auto,
    quote: DeliveryOrderQuote,
    pickup: DeliveryOrderPickup,
    dropoff: DeliveryOrderDropoff,
    order_items: Schema.Auto,
    distance: Schema.Number,
    created_at: {
        map: 'createdAt',
        mapImport: (value: string) =>
            getLocalMomentFromUtc(value, FORMAT.DATETIME_SERVER),
    },
    updated_at: {
        map: 'updatedAt',
        mapImport: (value: string) =>
            getLocalMomentFromUtc(value, FORMAT.DATETIME_SERVER),
    },
    pickup_at_ready: {
        map: 'pickupAtReady',
        mapImport: (value: string) =>
            getLocalMomentFromUtc(value, FORMAT.DATETIME_SERVER),
    },
    pickup_at_eta: {
        map: 'pickupAtEta',
        mapImport: (value: string) =>
            getLocalMomentFromUtc(value, FORMAT.DATETIME_SERVER),
    },
    pickup_at: {
        map: 'pickupAt',
        mapImport: (value: string) =>
            getLocalMomentFromUtc(value, FORMAT.DATETIME_SERVER),
    },
    dropoff_at_eta: {
        map: 'dropoffAtEta',
        mapImport: (value: string) =>
            getLocalMomentFromUtc(value, FORMAT.DATETIME_SERVER),
    },
    dropoff_at: {
        map: 'dropoffAt',
        mapImport: (value: string) =>
            getLocalMomentFromUtc(value, FORMAT.DATETIME_SERVER),
    },
    live_dropoff_at_eta: {
        map: 'liveDropoffAtEta',
        mapImport: (value: string) =>
            getLocalMomentFromUtc(value, FORMAT.DATETIME_SERVER),
    },
    live_pickup_at_eta: {
        map: 'livePickupAtEta',
        mapImport: (value: string) =>
            getLocalMomentFromUtc(value, FORMAT.DATETIME_SERVER),
    },
    full_service_provider: Schema.String,
    fee: Schema.Number,
    tip: Schema.Number,
    currency: Schema.String,
    tax: Schema.Number,
    total: Schema.Number,
    tracking_url: Schema.String,
    courier: DeliveryOrderCourier,
    driver: DeliveryOrderDriver,
    refund: DeliveryOrderRefund,
    requires_id: Schema.Boolean,
    requires_dropoff_signature: Schema.Boolean,
    deliverable_action: Schema.Auto,
    manager_note: DeliveryOrderManagerNote,
    attributes: Schema.Auto,
    location: Schema.Auto,
    company: Schema.Auto,
    error_code: Schema.String,
    service_provider: Schema.Auto,
    warnings: Schema.Auto,
    payment_methods: Schema.Auto
};
